namespace Portico.Models.Enterprise {
    import psge = apigateway.enums;
    import psgm = apigateway.models;

    export interface IPhoneNumber {
        id: number;
        type: number | string;
        number: string;
        extension: string;
        language: string;
        timeZone: string;
        bestDaysToCall: string;
        bestTimeToCall: string;
		contactDatePreferenceType: number | string;
		contactTimePreferenceType: number | string;
		purpose: number | string;
		isVoicemailOptedIn: boolean;
		isPrimary: boolean;

		mapToEnterpriseCoordinatorPhoneUpsearchModel(): psgm.EnterpriseCoordinatorSharedPhoneUpsearchModel;
	}

    export class PhoneNumber implements IPhoneNumber {
        id: number;
        type: number | string;
        number: string;
        extension: string;
        language: string;
        timeZone: string;
        bestDaysToCall: string;
        bestTimeToCall: string;
		contactDatePreferenceType: number | string;
		contactTimePreferenceType: number | string;
		purpose: number | string;
		isVoicemailOptedIn: boolean;
		isPrimary: boolean;

        constructor(obj?: IPhoneNumber | any) {
            this.id = null;
            this.type = null;
            this.number = '';
			this.extension = '';
			this.language = '';
			this.timeZone = '';
			this.bestDaysToCall = '';
			this.bestTimeToCall = '';
            this.contactDatePreferenceType = null;
            this.contactTimePreferenceType = null;
            this.purpose = null;
			this.isVoicemailOptedIn = false;
			this.isPrimary = false;

            if (obj) {
				this.id = obj.id || obj.phoneId || null;
				this.type = obj.type || obj.phoneType || null;
				this.number = obj.number || obj.phoneNumber || '';
				this.extension = obj.extension || '';
				this.language = obj.language || '';
				this.timeZone = obj.timeZone || '';
				this.bestDaysToCall = obj.bestDaysToCall || '';
				this.bestTimeToCall = obj.bestTimeToCall || '';
				this.contactDatePreferenceType = obj.contactDatePreferenceType || null;
				this.contactTimePreferenceType = obj.contactTimePreferenceType || null;
				this.purpose = obj.purpose || obj.phonePurpose || null;
				this.isVoicemailOptedIn = obj.isVoicemailOptedIn || false;
				this.isPrimary = obj.isPrimary || false;
            }
        }

        mapToEnterpriseCoordinatorPhoneUpsearchModel() : psgm.EnterpriseCoordinatorSharedPhoneUpsearchModel {
            return {
                phoneId: this.id,
                phoneType: typeof this.type === 'number' ? this.type : Portico.Models.Gateway.ContactInfoType[this.type],
                phonePurpose: typeof this.purpose === 'number'? this.purpose : Portico.Models.Gateway.ContactInfoPurposeType[this.purpose],
                phoneNumber: this.number,
                extension: this.extension,
                contactDatePreferenceType: typeof this.contactDatePreferenceType === 'number' ? this.contactDatePreferenceType : psge.ContactDatePreferenceType[this.contactDatePreferenceType],
                bestDaysToCall: this.bestDaysToCall,
                contactTimePreferenceType: typeof this.contactTimePreferenceType === 'number'?  this.contactTimePreferenceType : psge.ContactTimePreferenceType[this.contactTimePreferenceType],
                bestTimeToCall: this.bestTimeToCall,
                language: this.language,
                timeZone: this.timeZone
            } as psgm.EnterpriseCoordinatorSharedPhoneUpsearchModel
        }
    }
}
